import Swiper from 'swiper/bundle';
import featherlight from 'featherlight/release/featherlight.min';
import featherlightGallery from 'featherlight/release/featherlight.gallery.min';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

jQuery(function ($) {
    if ($('.module-animated_image_text').length > 0) {
        var sections = gsap.utils.toArray('.module-animated_image_text');

        sections.forEach(function (sec) {
            var forwardVideo = sec.querySelector('.forward-video video');
            var reverseVideo = sec.querySelector('.reverse-video video');

            // Function to reset videos
            var resetVideos = function () {
                if (forwardVideo && reverseVideo) {
                    forwardVideo.currentTime = 0;
                    forwardVideo.pause();
                    reverseVideo.currentTime = 0;
                    reverseVideo.pause();
                }
            };

            // Function to play forward video
            var playForwardVideo = function () {
                resetVideos();
                if (forwardVideo) {
                    forwardVideo.play();
                }
            };

            // Function to play reverse video
            var playReverseVideo = function () {
                resetVideos();
                if (reverseVideo) {
                    reverseVideo.play();
                }
            };

            gsap.from(sec, {
                scrollTrigger: {
                    start: 'top 70%',
                    end: 'bottom 70%',
                    trigger: sec,
                    invalidateOnRefresh: true,
                    onEnter: function onEnter(self) {
                        if (self.isActive) {
                            sec.classList.add('active');
                            playForwardVideo();
                        }
                    },
                    onLeave: function onLeave(self) {
                        sec.classList.remove('active');
                        playReverseVideo();
                    },
                    onEnterBack: function onEnterBack(self) {
                        if (self.isActive) {
                            sec.classList.add('active');
                            playForwardVideo();
                        }
                    },
                    onLeaveBack: function onLeaveBack(self) {
                        sec.classList.remove('active');
                        playReverseVideo();
                    },
                    onUpdate: function onUpdate(self) {
                        if (!self.isActive) {
                            resetVideos();
                        }
                    },
                },
            });
        });

        window.addEventListener('load', function () {
            ScrollTrigger.refresh();
        });
    }

    if ($('.swiper').length > 0) {
        $('.swiper').each(function () {
            // Get data-swiper attribute value
            var swiperElement = $(this);
            var module = $(this).closest('.module');
            var thumbs = module.find('.photo-gallery-thumbnails');
            var swiperSettings = swiperElement.data('swiper');

            var swiperOptions = Object.assign({}, swiperSettings,
                {loop: false,
                pagination: {
                    el: $(this).closest('.module').find('.swiper-pagination')[0], // Set pagination container
                    clickable: true, // Enable clickable pagination
                },
                navigation: {
                    nextEl: $(this).closest('.module').find('.swiper-button-next')[0],
                    prevEl: $(this).closest('.module').find('.swiper-button-prev')[0],
                }});

            if (thumbs.length > 0) {
                var swiperThumbs = new Swiper(thumbs[0], {
                    spaceBetween: 10,
                    slidesPerView: 2.5,
                    freeMode: true,
                    watchSlidesProgress: true,
                    breakpoints: {
                        768: {
                            slidesPerView: 3.5,
                        },
                        1024: {
                            slidesPerView: 4.5,
                        },
                    },
                });

                swiperOptions.thumbs = {
                    swiper: swiperThumbs,
                };
            }

            // Initialize Swiper
            var swiper = new Swiper(swiperElement[0], swiperOptions);

            if (swiperElement.find('.gallery').length > 0) {
                swiperElement.find('.gallery').featherlightGallery({
                    previousIcon: '',
                    nextIcon: '',
                    galleryFadeIn: 100,
                    galleryFadeOut: 300,
                    afterContent: function () {
                        bind_copy_url();

                        var $modal = this.$content.closest('.featherlight-content'); // The modal content inside Featherlight
                        $modal.attr('style', '');
                        resize_modal($modal);
                    },
                    afterResize: function () {
                        var $modal = this.$content.closest('.featherlight-content'); // The modal content inside Featherlight
                        $modal.attr('style', '');
                        resize_modal($modal);
                    },
                });
            }
        });
    }

    function resize_modal($modal) {
        // Get the modal's current dimensions
        var modalWidth = $modal.outerWidth();
        var modalHeight = $modal.outerHeight();
        var modalRatio = modalWidth / modalHeight;

        var newModalWidth = modalWidth;
        var newModalHeight = modalHeight;

        // If modal height exceeds the window height (with padding), adjust height and width
        if (modalHeight + 100 > window.innerHeight) {
            newModalHeight = window.innerHeight - 100;
            newModalWidth = newModalHeight * modalRatio;

            // Reset any existing styles and apply new dimensions
            $modal.attr('style', '');
            $modal.css({
                width: newModalWidth + 'px',
                height: newModalHeight + 'px',
            });
        }
        // If modal width exceeds the window width (with padding), adjust width only
        else if (modalWidth + 100 > window.innerWidth) {
            newModalWidth = window.innerWidth - 100;

            // Reset any existing styles and apply new width
            $modal.attr('style', '');
            $modal.css({
                width: newModalWidth + 'px',
            });
        } else {
            // If no adjustments are needed, reset styles
            $modal.attr('style', '');
        }
    }

    $('.read-more-wrapper').on('click', function () {
        var $wrapper = $(this);
        var $button = $wrapper.find('.read-more');
        var $content = $wrapper.prev('.read-more-content');
        if ($content.is(':visible')) {
            $content.slideUp();
            $button.text('Read More');
            $wrapper.find('.plus').css('display', 'inline-block');
            $wrapper.find('.minus').css('display', 'none');
        } else {
            $content.slideDown();
            $wrapper.find('.plus').css('display', 'none');
            $wrapper.find('.minus').css('display', 'inline-block');
            $button.text('Read Less');
        }
    });

    // Handle Anchors
    // Function to get URL parameters
    function getQueryParams() {
        var params = {};
        var queryString = window.location.search.substring(1);
        var regex = /([^&=]+)=([^&]*)/g;
        var m;
        while ((m = regex.exec(queryString))) {
            params[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
        }
        return params;
    }

    // Function to remove query parameters from URL but keep the hash
    function removeQueryParams() {
        var newUrl =
            window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.hash;
        history.pushState(null, '', newUrl);
    }

    // Flag to ensure the modal click event is only triggered once
    var modalTriggered = false;

    var params = getQueryParams();

    if (window.location.hash || params.anchor) {
        var target = window.location.hash || '#' + params.anchor;

        // Check if the target element exists
        var $targetElement = $(target);
        if ($targetElement.length) {
            // Animate scroll to the section
            $('html, body').animate(
                {
                    scrollTop: $targetElement.offset().top,
                },
                1000,
                function () {
                    // After scrolling, perform actions based on the 'modal' parameter
                    if (params.modal && !modalTriggered) {
                        var $modalLink = $targetElement.find('a[href="#modal-' + params.modal + '"]');
                        if ($modalLink.length) {
                            $modalLink.trigger('click');
                            modalTriggered = true; // Set flag to true after triggering
                        } else {
                            console.warn('Modal link not found.');
                        }
                    }
                    removeQueryParams();
                }
            );
        } else {
            console.warn('Target element not found.');
        }
    }

    // Navigation Toggle
    $('.nav-toggle').on('click', function () {
        var $control = $(this).attr('aria-controls');

        if ($(this).attr('aria-expanded') === 'true') {
            $('#' + $control).attr('aria-hidden', 'true');
            $(this).attr('aria-expanded', 'false');
            $('body').removeClass('modal-open');
            $('header').removeClass('active');
        } else {
            $(this).attr('aria-expanded', 'true');
            $('#' + $control).attr('aria-hidden', 'false');
            $('body').addClass('modal-open');
            $('header').addClass('active');
        }
    });

    // Copy URL Button
    function bind_copy_url() {
        $('.copy-url .button').on('click', function () {
            var $button = $(this);
            var $module = $button.closest('.module');
            var moduleId = $module.attr('id');
            var urlToCopy;

            // Determine the URL to copy
            if (moduleId) {
                // If moduleId exists, use the URL with the module ID
                urlToCopy = window.location.href + '#' + moduleId;
            } else {
                // If no moduleId, check for parent with class component-social-share
                var $socialShare = $button.closest('.component-social-share');
                if ($socialShare.length) {
                    urlToCopy = $socialShare.data('url');
                } else {
                    urlToCopy = window.location.href;
                }
            }

            var $tooltip = $button.siblings('.tooltip');

            // Check clipboard-read permission
            navigator.permissions.query({ name: 'clipboard-read' }).then(function (permissionStatus) {
                if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
                    // Use the modern clipboard API
                    if (navigator.clipboard) {
                        navigator.clipboard
                            .writeText(urlToCopy)
                            .then(function () {
                                // Temporarily change the tooltip text
                                $tooltip.text('Copied to Clipboard');
                                setTimeout(function () {
                                    $tooltip.text('Copy to Clipboard');
                                }, 2000); // Change back after 2 seconds
                            })
                            .catch(function () {
                                alert('Failed to copy the URL.');
                            });
                    } else {
                        // Fallback for browsers that don't support navigator.clipboard
                        var $tempInput = $('<input>');
                        $('body').append($tempInput);
                        $tempInput.val(urlToCopy).select();
                        document.execCommand('copy');
                        $tempInput.remove();

                        // Temporarily change the tooltip text
                        $tooltip.text('Copied to Clipboard');
                        setTimeout(function () {
                            $tooltip.text('Copy to Clipboard');
                        }, 2000);
                    }
                } else {
                    alert('Clipboard permissions denied.');
                }
            });
        });
    }

    // Call the function to bind the click event
    bind_copy_url();

    $('.component-icon.search').on('click', function () {
        $(this).closest('form').trigger('submit');
    });
});
